"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPodcastShowStencil = exports.podcastShowStencilDefinition = void 0;
const properties_1 = require("../properties");
const wrcErcContentAreas = [
    {
        name: 'main',
        items: [
            'header-media',
            'title',
            'subheading',
            'teaser',
            'description',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'seo-title',
                    'social-title',
                    'featured-title',
                    'featured-media',
                    'featured-video',
                    'podcast-preview',
                    'uri-title',
                    'hosts',
                    'language',
                    'logos',
                    'podcast-season-ref',
                ],
            },
            {
                name: 'CTA',
                items: ['cta-container'],
            },
            {
                name: 'Settings',
                items: [
                    'search-terms',
                    'standalone',
                    'no-monetization',
                ],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'disciplines',
            'content-categories',
            'tag-events',
            'tag-event-series',
            'tag-rally-drivers',
            'tag-rally-teams',
            'related-content',
        ],
    },
];
exports.podcastShowStencilDefinition = {
    view: {
        label: 'Podcast show',
        group: 'Audio',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'title',
                    'subheading',
                    'teaser',
                    'description',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'featured-media',
                            'featured-video',
                            'podcast-preview',
                            'uri-title',
                            'hosts',
                            'language',
                            'logos',
                            'podcast-season-ref',
                        ],
                    },
                    {
                        name: 'CTA',
                        items: ['cta-container'],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'standalone',
                            'no-monetization',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
        previewConfiguration: {
            hasPagePreview: true,
            hasFeatureCardPreview: true,
        },
    },
    content: {
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.ctaContainerPropertyDefinition.name]: properties_1.ctaContainerPropertyDefinition,
        [properties_1.descriptionPropertyDefinition.name]: properties_1.descriptionPropertyDefinition,
        [properties_1.disciplinesPropertyDefinition.name]: properties_1.disciplinesPropertyDefinition,
        [properties_1.featuredMediaPropertyDefinition.name]: properties_1.featuredMediaPropertyDefinition,
        [properties_1.featuredTitlePropertyDefinition.name]: properties_1.featuredTitlePropertyDefinition,
        [properties_1.featuredVideoPropertyDefinition.name]: properties_1.featuredVideoPropertyDefinition,
        [properties_1.headerMediaPropertyDefinition.name]: properties_1.headerMediaPropertyDefinition,
        [properties_1.hostsPropertyDefinition.name]: properties_1.hostsPropertyDefinition,
        [properties_1.languagePropertyDefinition.name]: properties_1.languagePropertyDefinition,
        [properties_1.logosPropertyDefinition.name]: properties_1.logosPropertyDefinition,
        [properties_1.noMonetizationPropertyDefinition.name]: properties_1.noMonetizationPropertyDefinition,
        [properties_1.podcastPreviewPropertyDefinition.name]: properties_1.podcastPreviewPropertyDefinition,
        [properties_1.podcastSeasonRefPropertyDefinition.name]: properties_1.podcastSeasonRefPropertyDefinition,
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.relatedContentPropertyDefinition.name]: properties_1.relatedContentPropertyDefinition,
        [properties_1.searchTermsPropertyDefinition.name]: properties_1.searchTermsPropertyDefinition,
        [properties_1.seoTitlePropertyDefinition.name]: properties_1.seoTitlePropertyDefinition,
        [properties_1.socialTitlePropertyDefinition.name]: properties_1.socialTitlePropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: properties_1.standalonePropertyDefinition,
        [properties_1.subheadingPropertyDefinition.name]: {
            ...properties_1.subheadingPropertyDefinition,
            constraints: [
                {
                    name: 'maxLength',
                    argument: 45,
                },
            ],
        },
        [properties_1.tagEventSeriesPropertyDefinition.name]: properties_1.tagEventSeriesPropertyDefinition,
        [properties_1.tagEventsPropertyDefinition.name]: properties_1.tagEventsPropertyDefinition,
        [properties_1.tagPersonsPropertyDefinition.name]: properties_1.tagPersonsPropertyDefinition,
        [properties_1.tagRallyDriversPropertyDefinition.name]: properties_1.tagRallyDriversPropertyDefinition,
        [properties_1.tagRallyTeamsPropertyDefinition.name]: properties_1.tagRallyTeamsPropertyDefinition,
        [properties_1.tagTeamsPropertyDefinition.name]: properties_1.tagTeamsPropertyDefinition,
        [properties_1.teaserPropertyDefinition.name]: {
            ...properties_1.teaserPropertyDefinition,
            constraints: [
                {
                    name: 'maxLength',
                    argument: 500,
                },
                {
                    name: 'required',
                    argument: true,
                },
            ],
        },
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.uriTitlePropertyDefinition.name]: properties_1.uriTitlePropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: [
        'batalla',
        'brand-building-events',
        'erc',
        'global',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'redbull-racing',
        'redbull-powertrains',
        'redbull_com',
        'redbulletin',
        'redbullmusic',
        'wingfinder',
        'wrc',
    ],
    name: 'podcast-show',
    overwrites: [
        {
            condition: 'space',
            argument: 'erc',
            contentAreas: wrcErcContentAreas,
        },
        {
            condition: 'space',
            argument: 'wrc',
            contentAreas: wrcErcContentAreas,
        },
    ],
};
const isPodcastShowStencil = (stencil) => {
    return stencil.name === exports.podcastShowStencilDefinition.name;
};
exports.isPodcastShowStencil = isPodcastShowStencil;
//# sourceMappingURL=data:application/json;base64,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